/* global AsLobasExtendData */
import $ from 'jquery';

$ (() => {
  const $target = $ ('#wpsl-result-list');

  if (!$target.length) {
    return;
  }

  const html = `
  <style>
    .wpsl-featured-logo-lobas {
      font-size: 0;
      line-height: 1;
      margin: 20px 0 8px;
      text-align: right;
    }

    .wpsl-featured-logo-lobas a {
      display: inline-block;
    }

    .wpsl-featured-logo-lobas img {
      display: block;
    }
  </style>
  <div class="wpsl-featured-logo-lobas">
    <a href="https://www.garasjer.no">
      <img src="${AsLobasExtendData.assetsSrcUrl}igland-logo.jpg" width="300" height="67">
    </a>
  </div>`;

  $target.before (html);
});
